module.exports = __webpack_public_path__ + "static/img/6.b64ae6c.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/issue12/03/6.jpeg
// module id = 2IAo
// module chunks = 7